<template>
  <div class="entryContainer">
    <!-- 入职详情 -->
    <div class="selectDate">
      <label>*日期：</label>
      <a-date-picker v-model="day" />
    </div>
    <div class="selectDate">
      <label>*渠道：</label>
      <a-select
        style="min-width:200px"
        v-model="resume_source_id"
        showSearch
        :filterOption="filterOption"
      >
        <a-select-option
          :value="element.id"
          v-for="(element, k) in channelList"
          :key="k"
          >{{ element.source_name }}</a-select-option
        >
      </a-select>
    </div>
    <ul class="edtryContent">
      <li>
        <label>*项目：</label>
        <a-select v-model="project_id" showSearch :filterOption="filterOption">
          <a-select-option
            v-for="element in proList"
            :key="element.id"
            :value="element.id"
            >{{ element.project_name }}</a-select-option
          >
        </a-select>
      </li>
      <li>
        <label>*上贴数量：</label>
        <a-input-number v-model="num" :min="0" />
      </li>
      <li>
        <label>*花费成本：</label>
        <a-input-number v-model="price" :min="0" />
      </li>
    </ul>
    <!-- 入职详情 end -->
    <div class="submitStyle">
      <a-button type="primary" @click="submitFrom">确定</a-button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
let moment = require("moment");
export default {
  data() {
    return {
      details: {},
      addBusiness: [
        {
          addIcon: require("../../assets/resume/add.png"),
          addTitle: "增加",
          price: "",
          num: "",
          proVal: ""
        }
      ],
      roleList: [],
      roleVal: [],
      proList: [],
      proVal: "",
      validateForm: {
        proVal: "",
        roleVal: ""
      },
      channelList: [],
      day: moment(),
      resume_source_id: "",
      project_id: "",
      num: "",
      price: ""
    };
  },
  props: {
    editDetail: {}
  },
  mounted() {
    this.details = this.editDetail;
    this.getPro(); //项目列表
    this.getChannel(); //获取渠道
  },
  watch: {
    editDetail() {
      this.details = this.editDetail;
      this.getDetail(); //获取详情
      console.log(this.details);
    }
  },
  methods: {
    getDetail() {
      this.resume_source_id = this.details.resume_source_id;
      this.project_id = this.details.project_id;
      this.num = this.details.num;
      this.price = Number(this.details.price);
      this.day = moment(this.details.day);
    },
    getChannel() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_source/resumeSourceList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.channelList = res.data.data.data;
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChangeDate(date) {
      // console.log(date);
    },
    submitFrom() {
      let project_list_data = [];
      project_list_data.push({
        project_id: this.project_id,
        num: this.num,
        price: this.price
      });
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        day: moment(this.day).format("YYYY-MM-DD"),
        id: this.details.id,
        resume_source_id: this.resume_source_id,
        project_list_data: JSON.stringify(project_list_data)
      };
      // console.log(params);
      let url =
        this.httpsBasic.url + this.httpsBasic.recruitment + "Day/editDay";
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("提交成功");
            this.handleReset();
            // _this.$router.push({ name: "resume" });
            this.$emit("hideInEdit", false);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    handleReset() {
      this.day = moment();
      this.resume_source_id = "";
    }
  }
};
</script>
<style lang="less" scoped>
.entryContainer {
  padding: 30px 10%;
  .selectDate {
    margin-bottom: 20px;
  }
  .submitStyle {
    text-align: center;
    width: 300px;
    margin-top: 50px;
  }
  h2 {
    font-weight: normal;
  }
  .infoBasic {
    margin: 10px 0;
    li {
      display: flex;
      flex-direction: row;
      margin-bottom: 6px;
    }
  }
  .edtryContent {
    margin-bottom: 20px;
    li {
      margin-bottom: 10px;
      > div {
        width: 200px;
        margin-right: 20px;
      }
      textarea {
        font-size: 14px;
        line-height: 20px;
        padding: 10px;
        display: inline-block;
        max-width: 200px;
        vertical-align: top;
      }
    }
  }
}
</style>
